"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _max = _interopRequireDefault(require("lodash/max"));
var _min = _interopRequireDefault(require("lodash/min"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _TableControls = _interopRequireDefault(require("./TableControls"));
const TableFooter = ({
  rowSize,
  pageSize,
  totalDataRowCount,
  currentPage,
  totalPages,
  currentPageLength,
  showMessage,
  message,
  onPageChange,
  onPreviousPage,
  onNextPage
}) => {
  const classes = (0, _classnames.default)('TableFooter', {
    'TableFooter-large': rowSize === 'large'
  });
  const totalCount = (0, _max.default)([currentPageLength, totalDataRowCount]);
  const displayMessage = message ? message : totalPages > 1 ? `Showing ${(currentPage - 1) * pageSize + 1}-${(0, _min.default)([currentPage * pageSize, totalCount])} of ${totalCount}` : `Showing ${currentPageLength} of ${totalCount}`;
  if (!currentPageLength) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "TableFooter-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes
  }, showMessage && /*#__PURE__*/_react.default.createElement("div", {
    className: "TableFooter-info"
  }, displayMessage), totalPages > 1 && /*#__PURE__*/_react.default.createElement(_TableControls.default, {
    currentPage: currentPage,
    totalPages: totalPages,
    onPageChange: onPageChange,
    onPreviousPage: onPreviousPage,
    onNextPage: onNextPage
  })));
};
var _default = exports.default = /*#__PURE__*/_react.default.memo(TableFooter);